import { render } from "./OwnerProperties.vue?vue&type=template&id=23e08c42"
import script from "./OwnerProperties.vue?vue&type=script&lang=js"
export * from "./OwnerProperties.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__